import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  TagIcon,
  CalendarIcon,
  CurrencyRupeeIcon,
  ClipboardDocumentListIcon,
  ArrowLeftIcon,
  CircleStackIcon,
  AdjustmentsHorizontalIcon,
  BoltIcon,
} from "@heroicons/react/24/outline";
import api from "../../api";

const KittyView = () => {
  const { id } = useParams();
  const [kitty, setKitty] = useState(null);

  useEffect(() => {
    api.get(`/kitties/${id}`).then((res) => {
      // ✅ FIXED: use res.data.data instead of res.data
      if (res.data && res.data.success) {
        setKitty(res.data.data);
      } else {
        setKitty(res.data);
      }
    });
  }, [id]);

  if (!kitty) {
    return <div className="p-6 text-center text-gray-500">Loading kitty...</div>;
  }

  return (
    <div className="p-8 max-w-3xl mx-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-8">
        <div className="flex items-center gap-2">
          <TagIcon className="h-7 w-7 text-purple-600" />
          <h1 className="text-3xl font-bold text-gray-800">{kitty.kitty_name}</h1>
        </div>

        <Link
          to="/jewellers/kittyList"
          className="flex items-center gap-1 bg-purple-500 text-white px-4 py-2 rounded-xl shadow hover:bg-purple-700 transition-all duration-200"
        >
          <ArrowLeftIcon className="h-5 w-5" /> Back
        </Link>
      </div>

      {/* Info Card */}
      <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8 space-y-6">
        {/* Status and Type */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex items-center gap-3">
            <AdjustmentsHorizontalIcon className="h-5 w-5 text-purple-500" />
            <div>
              <p className="text-gray-500 text-sm">Kitty Type</p>
              <p className="font-medium capitalize">{kitty.kitty_type}</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <BoltIcon className="h-5 w-5 text-purple-500" />
            <div>
              <p className="text-gray-500 text-sm">Status</p>
              <span
                className={`inline-block px-3 py-1 text-sm rounded-full font-medium ${kitty.status === "active"
                    ? "bg-green-100 text-green-700"
                    : kitty.status === "paused"
                      ? "bg-yellow-100 text-yellow-700"
                      : "bg-gray-200 text-gray-700"
                  }`}
              >
                {kitty.status}
              </span>
            </div>
          </div>
        </div>

        {/* Amounts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex items-center gap-3">
            <CurrencyRupeeIcon className="h-5 w-5 text-purple-500" />
            <div>
              <p className="text-gray-500 text-sm">Monthly Per Kitty Amount</p>
              <p className="font-semibold text-gray-800">
                ₹ {kitty.target_amount || 0}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <CurrencyRupeeIcon className="h-5 w-5 text-purple-500" />
            <div>
              <p className="text-gray-500 text-sm">Total Monthly Target</p>
              <p className="font-semibold text-gray-800">
                ₹ {Number(kitty.target_amount) * Number(kitty.number_of_tokens)}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <CurrencyRupeeIcon className="h-5 w-5 text-purple-500" />
            <div>
              <p className="text-gray-500 text-sm">Collected Amount</p>
              <p className="font-semibold text-gray-800">
                ₹ {kitty.collected_amount || 0}
              </p>
            </div>
          </div>
        </div>

        {/* Dates */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex items-center gap-3">
            <CalendarIcon className="h-5 w-5 text-purple-500" />
            <div>
              <p className="text-gray-500 text-sm">Start Date</p>
              <p className="font-medium text-gray-800">
                {kitty.start_date || "—"}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <CalendarIcon className="h-5 w-5 text-purple-500" />
            <div>
              <p className="text-gray-500 text-sm">End Date</p>
              <p className="font-medium text-gray-800">
                {kitty.end_date || "—"}
              </p>
            </div>
          </div>
        </div>

        {/* Notes */}
        <div className="flex items-start gap-3 pt-2">
          <CircleStackIcon className="h-5 w-5 text-purple-500 mt-1" />
          <div>
            <p className="text-gray-500 text-sm mb-1">Total Number of tokens</p>
            <p className="text-gray-700 whitespace-pre-line leading-relaxed">
              {kitty.number_of_tokens || "—"}
            </p>
          </div>
        </div>

        {/* Notes */}
        <div className="flex items-start gap-3 pt-2">
          <ClipboardDocumentListIcon className="h-5 w-5 text-purple-500 mt-1" />
          <div>
            <p className="text-gray-500 text-sm mb-1">Notes</p>
            <p className="text-gray-700 whitespace-pre-line leading-relaxed">
              {kitty.description || "—"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KittyView;
